<template>
  <div class="SelectProjectOrder">
    <div class="tabWrap">
      <div class="approve-rule">
        <span @click="SeeApproveRule">查看立项审批制度</span>
      </div>
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dialogForm"
              label-width="150px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="所属合同" prop="generalContractId">
                    <el-input
                      size="large"
                      v-model="dialogForm.generalContractName"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目类型" prop="projectTypeKey">
                    <el-select
                      @change="projecttypechange"
                      v-model="dialogForm.projectTypeKey"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      :disabled="true"
                      style="width: 100%"
                    >
                      <el-option
                        :label="item.value"
                        :value="item.label"
                        v-for="(item, index) in projectTypeList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目编号">
                    <el-input
                      size="large"
                      v-model="dialogForm.serialNumber"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目名称" prop="name">
                    <el-input
                      size="large"
                      v-model="dialogForm.name"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目地址">
                    <el-input
                      size="large"
                      v-model="dialogForm.address"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目信息" prop="projectInfo">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入内容"
                      v-model="dialogForm.projectInfo"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开工日期">
                    <el-date-picker
                      v-model="dialogForm.startDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预计完工日期">
                    <el-date-picker
                      v-model="dialogForm.expectFinishDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="预计交工验收日期">
                    <el-date-picker
                      v-model="dialogForm.expectFinishCheckDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预计审计日期">
                    <el-date-picker
                      v-model="dialogForm.expectAuditDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="预计竣工验收日期">
                    <el-date-picker
                      v-model="dialogForm.expectCompleteCheckDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="缺陷责任期日期">
                    <el-date-picker
                      v-model="dialogForm.defectLiabilityDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="申请人" prop="applyUserName">
                    <el-input
                      v-model="dialogForm.applyUserName"
                      :editable="false"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申请部门" prop="applyDeptId">
                    <el-input
                      v-model="dialogForm.applyDeptName"
                      :editable="false"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="单据状态:">{{
                    dialogForm.approveStatusName
                  }}</el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="流水号:">{{
                    dialogForm.flowNo
                  }}</el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="单据日期:">{{
                    dialogForm.createTime
                  }}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="second"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dialogForm.projectItemsVOList"
            :itemId="projectId"
            :approveStatus="dialogForm.approveStatus"
            :isUploadAllowed="dialogForm.isUploadAllowed"
            :type="approveType"
            @saveUpdateFile="getProjectDetail(projectId)"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="third"
          style="text-align: left;"
          class="firstTab"
        >
          <div v-if="approveFlag === 'currentApprove'">
            <approveItem
              :itemId="projectId"
              :approveType="approveType"
              @finishApprove="close1"
            >
            </approveItem>
          </div>
          <div v-else>
            <approveLine
              :itemId="projectId"
              :approveType="approveType"
            ></approveLine>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="bottomBtn">
        <el-button type="info" @click="close1">关 闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getContractCodeByUserCodeService, //获取下拉列表数据
  getBasicDataListService, //获取项目类型下拉列表
  getProjectDetailService, //获取一条项目信息
} from "@/services/allContractServices";
import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem"; //历史审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件
import {goBackApprove} from '@/page/approveComponents/approve'

export default {
  name: "SelectProjectOrder",
  components: {
    approveLine, //审批流程
    approveItem,
    upLoadFileDialog, //上传附件
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "PROJECT", //审批类型
      approveFlag: '', //false：查看 true：审批
      span: 24,
      belongContractList: [], //所属合同下拉列表
      projectTypeList: [], //项目类型下拉列表
      RouteParam: {}, //存储路由跳转参数
      category: "GENERAL_CONTRACT_NAME", //下拉列表类型，默认所属合同名称
      currentUserId: "",
      projectId: 0,
      dialogForm: {
        //基础信息form表单
        applyDeptId: 0, //申请人部门
        applyDeptName: "", //申请人部门名称
        applyUserId: 0, //申请人ID
        applyUserName: "", //申请人姓名
        approveStatus: null, //审批状态
        approveUserId: "", //当前审批人
        province: "", //省
        city: "", //城市
        area: "", //区
        address: "", //详细地址
        createTime: "", //城市
        expectAuditDate: "", //预计审计日期
        defectLiabilityDate: "", //缺陷责任期日期
        expectCompleteCheckDate: "", //预计竣工验收日期
        expectFinishCheckDate: "", //预计交工验收日期
        expectFinishDate: "", //预计完工日期
        generalContractAmount: "", //对应总包合同的金额
        generalContractId: "", //总包合同id
        generalContractName: "", //总包合同名称
        name: "", //项目名称
        profit: "", //项目利润
        projectInfo: "", //项目信息
        projectTypeKey: "", //项目类型编码
        projectTypeName: "", //项目类型名称
        serialNumber: "", //项目编号
        startDate: "", //开工日期
        projectItemsDtoList: [], //附件列表
      },
      rules: {
        serialNumber: [
          { required: true, message: "请填写项目编号", trigger: "change" },
          {
            min: 3,
            max: 30,
            message: "长度在 3 到 30 个字符",
            trigger: "change",
          },
        ],
        generalContractId: [
          { required: true, message: "请选择所属合同", trigger: "change" },
        ],

        projectTypeKey: [
          { required: true, message: "请选择所属项目类型", trigger: "change" },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        area: [{ required: true, message: "请选择区", trigger: "change" }],
        address: [
          { required: true, message: "请填写详细地址", trigger: "change" },
        ],
        projectInfo: [
          { required: true, message: "请填写项目信息", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择开工日期", trigger: "change" },
        ],
        expectFinishDate: [
          { required: true, message: "请选择预计完工日期", trigger: "change" },
        ],
        expectFinishCheckDate: [
          {
            required: true,
            message: "请选择预计交工验收日期",
            trigger: "change",
          },
        ],
        expectAuditDate: [
          { required: true, message: "请选择预计审计日期", trigger: "change" },
        ],
        expectCompleteCheckDate: [
          {
            required: true,
            message: "请选择预计竣工验收日期",
            trigger: "change",
          },
        ],
        applyUserName: [
          { required: true, message: "请填写申请人", trigger: "blur" },
        ],
        applyDeptId: [
          { required: true, message: "请填写申请部门", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.category = "GENERAL_CONTRACT_NAME"; //合同名称
    this.getContractCode(this.category); //获取合同名称下拉框数据
    this.category = "PROJECTTYPE"; //项目类型
    this.getProjectTypeCode(this.category); //获取项目类型下拉框数据
    this.currentUserId = sessionStorage.getItem("currentUserId");
  },
  mounted() {
    let ch = document.documentElement.clientHeight - 80;
    document.getElementsByClassName("SelectProjectOrder")[0].style.height =
      ch + "px";
    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 80;
        document.getElementsByClassName("SelectProjectOrder")[0].style.height =
          ch1 + "px";
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.activeName = "first";
      this.approveFlag = this.tabRouteParam?.approveFlag ?? '';
      this.RouteParam = this.tabRouteParam;
      this.projectId = this.tabRouteParam.id;
      this.getProjectDetail(this.projectId);

      // this.category = "GENERAL_CONTRACT_NAME"; //合同名称
      // this.getContractCode(this.category); //获取合同名称下拉框数据
    },

    //获取category下拉框数据
    getContractCode(category) {
      let param = {};
      param.category = category;
      getContractCodeByUserCodeService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.ContractnameList = res.data; //合同名称
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    //获取一条项目信息
    getProjectDetail() {
      if (this.RouteParam) {
        let param = {};
        param.id = this.projectId;
        getProjectDetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.dialogForm = res.data;
              this.dialogForm.address =
                this.dialogForm.province +
                " " +
                this.dialogForm.city +
                " " +
                this.dialogForm.area +
                " " +
                this.dialogForm.address;
                this.dialogForm.isUploadAllowed=this.dialogForm.approveStatus==3?true:false;
              // this.dialogForm.itemApproveProcessVOs =
              //   res.data.itemApproveProcessVOs;
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    close() {
      let that = this;
      // this.$router.back();
      this.bus.$emit("tabClose", "addHouseDelive");
      this.bus.$emit("navMenuChange", {
        routeId: this.nextPath,
        routeParam: {
          complCode: this.callBackPageId,
          areaCode: that.form.areaCode,
          orderTypeFlag: this.orderTypeFlag,
          routeId: "order-detail",
        },
        pageId: this.callBackPageId,
      });
    },
    //获取合同name
    getContractName(val) {
      let obj = {};
      obj = this.ContractnameList.find((item) => {
        return item.id == val; //筛选出匹配数据
      });
      this.dialogForm.generalContractName = obj.name;
    },
    //数据改变时更新数据
    handleChange(value) {
      let len = value.length;
      this.dialogForm.applyDeptId = value[len - 1];
      //  let labal = this.$refs["cascaderAddr"].currentLabels; //注意2： 获取label值
    },
    //焦点离开时处理label
    handleDeptName(val) {
      if (!val) {
        console.log("1111");
        // let labal = this.$refs["cascaderAddr"].currentLabels; //注意2： 获取label值
        // this.dialogForm.applyDeptName = labal[labal.length - 1];
      }
    },
    //获取项目类型即合同分类下拉框数据
    getProjectTypeCode(category) {
      let param = {};
      param.category = category;
      getBasicDataListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "PROJECTTYPE") {
              this.projectTypeList = res.data; //项目类型即总包合同分类
            } else {
              this.contractCodeList = res.data; //总包合同编码
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    //项目类型改变事件
    projecttypechange(val) {
      let obj = {};
      obj = this.projectTypeList.find((item) => {
        return item.label == val; //筛选出匹配数据
      });
      this.dialogForm.projectTypeName = obj.value;
    },
    ShowApplyUserDia() {
      this.applyUserDiaVisible = true;
    },
    //存储申请人
    saveApplyUser(selectItems) {
      this.dialogForm.applyUserId = selectItems.applyUserId;
      this.dialogForm.applyUserName = selectItems.applyUserName;
      this.dialogForm.applyDeptId = selectItems.applyDeptId;
      this.dialogForm.applyDeptName = selectItems.applyDeptName;
      //  this.$set(this.dialogForm.applyUserName);
      this.applyUserDiaVisible = false;
    },
    //查看立项审批制度
    SeeApproveRule() {
      this.bus.$emit("navMenuChange", {
        routeId: "ApproveRule",
      });
    },
    close1() {
       if (this.approveFlag) {
        goBackApprove(this.approveFlag,'addHouseDelive')
      } else {
        this.bus.$emit("tabClose", "houseDeliveMgr");
        this.bus.$emit("navMenuChange", {
          routeId: "payment-parkfeeRelation",
        });
      }
    },
  },
};
</script>


<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.SelectProjectOrder {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    //  /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 80px);
        padding: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
  }

  .bottomBtn {
    position: fixed;
    // border-top: 1px solid #e6e6e6;
    // width: 60%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    left: 620px;
    bottom:28px ;
  }
}
 /deep/.ApproveItem .bottomBtn{
      bottom: 32px;
      z-index: 10;
      left: 500px;
    }

.screenPanel {
  text-align: left;
  height: auto;
}

.approve-rule {
  color: red;
  /* text-align: right; */
  position: absolute;
  right: 30px;
  top: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;
}

.btnList {
  text-align: center;
  margin-top: 20px;
}

/deep/ .el-header {
  position: relative;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
.el-select {
  width: 100%;
}
.el-cascader {
  width: 100%;
}

/deep/ .el-tabs__header {
  padding-right: 0px !important;
}
.firstTab {
  width: 70%;
}
@media only screen and(max-width:1680px) {
  .firstTab {
    width: 80%;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
